<style scoped>
.header {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 88px;
  opacity: 1;
  display: flex;
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: rgba(120, 120, 120, 0.4);
  z-index: 999;
  background: #fff;
  padding: 0px 360px;
}
.header1 {
  width: 1200px;
  height: 88px;
  display: flex;
  margin: 0 auto;
}
.header2 {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 88px;
  opacity: 1;
  display: flex;
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: rgba(120, 120, 120, 0.4);
  z-index: 999;
  background: #fff;
  padding: 0px 250px;
}
.logo_image {
  width: 145px;
  height: 44px;
  margin: 22px 108px 22px 0px;
}
.tabs {
  display: flex;
  height: 88px;
  line-height: 88px;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  flex: 1;
  font-variation-settings: "opsz" auto;
  color: #172b2f;
}
.pr50 {
  padding-right: 50px;
}
.pr24 {
  padding-right: 24px;
}
.ziyuan {
  cursor: pointer;
}
.login {
  display: flex;
  height: 88px;
  line-height: 88px;
  /* margin-left: 470px; */
}
.login-button {
  width: 100px;
  height: 40px;
  background: #227110;
  margin-top: 24px;
  color: #ffffff;
  border-radius: 20px;
  font-family: PingFang SC;
}
.carousel {
  height: 1080px;
}
.el-carousel {
  height: 1080px;
}
.scheme {
  position: relative;
  height: 1125px;
  background: #f5f7f9;
  margin-top: -10px;
}
.scheme-header {
  width: 100%;
  font-family: Source Han Sans;
  font-size: 64px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  padding: 110px 0px 24px 0px;
  background: #f5f7f9;
}
.scheme-header-subtitle {
  width: 100%;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  background: #f5f7f9;
}
.scheme-tabs {
  width: 615px;
  height: 60px;
  border-radius: 30px;
  opacity: 1;

  /* 自动布局 */
  display: flex;
  flex-direction: undefined;
  justify-content: undefined;
  align-items: undefined;
  padding: NaNpx;

  background: #ffffff;
  margin: 60px auto 69px;
}
.scheme-tab-item {
  flex: 1;
  text-align: center;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 8px 0px;
  cursor: pointer;
}
.scheme-tab-item-active {
  color: #fff;
  background-image: url("../assets/bg1.png");
  background-size: cover;
}
.scheme-tab-contents {
  display: flex;
  width: 1183px;
  height: 531px;
  margin: 0 auto;
}
.scheme-tab-contents2 {
  display: flex;
  width: 1183px;
  height: 531px;
  margin: 0 auto;
}
.tab-contents-item {
  position: relative;
  width: 373px;
  background: #ffffff;
  border-radius: 24px;
  cursor: pointer;
}
.tab-contents-item-active {
  width: 389px;
  height: 563px;
  color: #fff;
  background: linear-gradient(195deg, #42a421 2%, #2e7516 90%);
  margin-top: -20px !important;
}
.mlr32 {
  margin: 0px 32px;
}
.bgr {
  background: red;
}
.bgo {
  background: orange;
}
.bgg {
  background: green;
}
.tab-contents-item-text1 {
  font-family: Source Han Sans;
  font-size: 24px;
  font-weight: 500;
  text-align: left;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 40px 0px 16px 40px;
}
.tab-contents-item-text2 {
  margin: 0px 0px 24px 40px;
}
.tab-contents-item-text2-left {
  font-family: Montserrat;
  font-size: 54px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  /* 主色 */
  color: #2e7516;
}
.tab-contents-item-text2-right {
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
  padding-left: 16px;
}
.line1 {
  width: 293px;
  height: 0px;
  border-top: 1px solid #d8d8d8;
  margin: 24px auto;
}
.moneny {
  font-family: Montserrat;
  font-weight: 600;
  font-size: 36px;
  font-variation-settings: "opsz" auto;
  color: #2e7516;
}
.crp {
  cursor: pointer;
}
.df {
  display: flex;
}
.text1 {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 8px 25px 0px 40px;
}
.text2 {
  width: 197px;
  height: 40px;
  line-height: 40px;
  opacity: 1;

  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  background: #f5f7f9;
  border-radius: 8px;
}
.text3 {
  margin: 16px 0px 0px 40px;
}
.gou-img {
  width: 18px;
  height: 13px;
  margin-right: 16px;
}
.gou-text {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
}
.text3-button {
  width: 293px;
  height: 54px;
  border-radius: 27px;
  opacity: 1;

  /* 主色 */
  background: #2e7516;
  margin: 10px auto 0px;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: 54px;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
}
.text3-button-active {
  background: #fff;
  color: #2e7516;
}
.mb39 {
  margin-bottom: 39px;
}
.poa40 {
  position: absolute;
  left: 40px;
  bottom: 16px;
}
.fanyi-function {
  background: #ffffff;
}
.fanyi-function-title {
  width: 816px;
  font-family: Source Han Sans;
  font-size: 48px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 110px auto 32px;
}
.fanyi-function-subtitle {
  width: 567px;
  margin: 0px auto 60px;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #757575;
}
.fanyi-function-tabs {
  display: flex;
  width: 749px;
  margin: 0px auto 60px;
}
.fanyi-function-tab-item {
  width: 223px;
  height: 60px;
  border-radius: 30px;
  background: #f5f7f9;
  line-height: 60px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
}
.fanyi-function-tab-item-active {
  color: #fff;
  background: #2e7516;
}
.fanyi-function-tab-img {
  width: 1197px;
  height: 598px;
  margin: 0 auto 180px;
  background-image: url("../assets/beiji3.png");
  background-size: cover;
  text-align: center;
}
.fanyi_image {
  width: 1009px;
  margin: 56px auto 0px;
}
.fanyi-function-imgs {
  display: flex;
  width: 1200px;
  height: 456px;
  margin: 0 auto 180px;
}
.fanyi-function-img-item {
  width: 360px;
  cursor: pointer;
  border-radius: 24px;
}
.fanyi-function-img-item:hover {
  box-shadow: 0px 0px 39px 0px rgba(34, 113, 16, 0.3);
  border-radius: 24px;
}
.intelligent-agent {
  width: 100%;
  background: #f5f7f9;
}
.intelligent-agent-content {
  display: flex;
  width: 1199px;
  height: 869px;
  margin: 0 auto;
}
.intelligent-agent-content-left {
  width: 525px;
  margin-right: 116px;
}
.intelligent-agent-content-right {
  width: 558px;
  height: 588px;
  background-image: url("../assets/intelligent-right-img.png");
  background-size: cover;
  margin-top: 122px;
  border-radius: 15px;
}
.mlf40 {
  margin: 0px 40px;
}
.mlr60 {
  margin: 0px 60px;
}
.text5 {
  font-family: Source Han Sans;
  font-size: 40px;
  font-weight: bold;
  line-height: 72px;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 182px 0px 24px 0px;
}
.text6 {
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: 26px;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #787878;
  margin-bottom: 38px;
}
.intelligent-text1 {
  display: flex;
  width: 154px;
  height: 59px;
  line-height: 59px;
  border-radius: 16px;
  background: #ffffff;
  margin-right: 24px;
}
.icon-img {
  width: 24px;
  height: 24px;
  margin: 18px 16px 0px 16px;
}
.icon-text {
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 主色 */
  color: #2e7516;
}
.intelligent-button {
  display: flex;
  width: 176px;
  height: 68px;
  border-radius: 35px;
  opacity: 1;
  margin-top: 102px;
  background-image: url("../assets/intelligent-button.png");
  background-size: cover;
  cursor: pointer;
}
.support {
  height: 869px;
}
.support-content {
  width: 1199px;
  height: 869px;
  margin: 0 auto;
}
.support-content-title {
  width: 336px;
  font-family: Source Han Sans;
  font-size: 48px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 120px auto 78px;
}
.support-contents {
  display: flex;
  width: 1200px;
  height: 305px;
  margin: 0 auto;
}
.support-content-item {
  width: 360px;
  height: 305px;
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
}
.icon3-img {
  width: 68px;
  height: 68px;
  margin: 24px;
}
.icon3-text {
  font-family: Source Han Sans;
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin-top: 32px;
}
.text7 {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
  margin: 8px 24px 0px 24px;
}
.support-footer {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  width: 1200px;
  height: 79px;
  margin: 250px auto 0px;
  overflow: hidden;
}
.support-footer-front {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 130px;
  height: 150px;
  z-index: 999;
}
.support-footer-after {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 130px;
  height: 150px;
  z-index: 999;
}
.support-footer-img1 {
  width: 165px;
  height: 59px;
  margin-right: 80px;
}
.support-footer-img2 {
  width: 180px;
  height: 63px;
  margin-right: 80px;
}
.support-footer-img3 {
  width: 207px;
  height: 52px;
  margin-right: 80px;
}
.support-footer-img4 {
  width: 222px;
  height: 79px;
  margin-right: 80px;
}
.support-footer-img5 {
  width: 222px;
  height: 74px;
  margin-right: -110px;
}
.footer {
  width: 100%;
  height: 440px;
  background-image: url("../assets/footer-bg.png");
  background-size: cover;
}
.footer-content {
  width: 1199px;
  margin: 0 auto;
}
.footer_image {
  width: 100%;
  height: 100%;
}
.footer-title {
  width: 1200px;
  height: 262px;
  margin: 0 auto;
  background-image: url("../assets/footer-bg2.png");
  background-size: cover;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 辅色 */
  color: #172b2f;
}
.footer-bottom {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  height: 350px;
  margin: 0 auto;
}
.footer-bottom-left {
  flex: 1;
}
.footer-bottom-right {
  display: flex;
  flex: 1;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
  cursor: pointer;
  margin: 120px 0px 0px 220px;
  text-align: center;
}
.tab-active {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #2e7516;
  text-align: center;
}
.tab-active-text {
  border-bottom: 3px solid #227110;
  padding-bottom: 6px;
  color: #2e7516;
}
.resources {
  position: fixed;
  display: flex;
  height: 96px;
  top: 104px;
  left: 470px;
  z-index: 9999;
}
.console-panel {
  position: fixed;
  width: 208px;
  height: 135.5px;
  top: 44px;
  /* right: 300px; */
  right: 350px;
  z-index: 9999;
  background-image: url("../assets/console-panel-bg.png");
  background-size: cover;
  box-sizing: border-box;
  padding-top: 44px;
}
.console-panel-en {
  position: fixed;
  width: 208px;
  height: 135.5px;
  top: 44px;
  /* right: 300px; */
  right: 250px;
  z-index: 9999;
  background-image: url("../assets/console-panel-bg.png");
  background-size: cover;
  box-sizing: border-box;
  padding-top: 44px;
}
.console-panel-text1 {
  width: 124px;
  height: 40px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #2e7516;
  padding: 10px 0px 10px 24px;
  box-sizing: border-box;
  cursor: pointer;
  margin: 0 auto;
}
.console-panel-active {
  background: #fafafa;
  border-radius: 8px;
}
.console-panel-text2 {
  width: 124px;
  height: 40px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding: 10px 0px 10px 24px;
  box-sizing: border-box;
  cursor: pointer;
  margin: 0 auto;
  border-radius: 8px;
}
.resources-content {
  display: flex;
  width: 980px;
  margin: 0 auto;
  border-radius: 24px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
}
.resources-content-item {
  width: 284px;
  height: 66px;
  margin: 15px 0px 15px 24px;
  padding: 10px 0px 0px 24px;
  box-sizing: border-box;
  cursor: pointer;
}
.resources-content-item-text1 {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #2e7516;
}
.resources-content-item-text2 {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
}
.resources-content-item-active {
  border-radius: 16px;
  background: #fafafa;
}
.freeTrialImg {
  width: 176px;
  height: 68px;
  position: absolute;
  z-index: 99999;
  top: 70%;
  left: 50%;
  transition: transform 0.3s ease;
  transform: translate(-50%, -50%); /* 同时水平和垂直居中 */
  cursor: pointer;
  background-image: url("../assets/free-trial-button.png");
  background-size: cover;
}
.freeTrialImg:hover {
  background-image: url("../assets/free-trial-button-hover.png");
  background-size: cover;
}
.freeTrialImg2 {
  width: 176px;
  height: 68px;
  position: absolute;
  z-index: 99999;
  top: 74%;
  left: 23%;
  transition: transform 0.3s ease;
  transform: translate(-50%, -50%); /* 同时水平和垂直居中 */
  cursor: pointer;
  background-image: url("../assets/free-trial-button2.png");
  background-size: cover;
}
.freeTrialImg2:hover {
  background-image: url("../assets/free-trial-button-hover2.png");
  background-size: cover;
}
.consult {
  /* position: absolute;
  right: -326px;
  top: 297px;
  z-index: 99999; */
  position: fixed;
  top: 650px;
  right: 16px;
  z-index: 999;
}
.scan {
  position: fixed;
  right: 80px;
  top: 520px;
  z-index: 9999;
  width: 194px;
  height: 224px;
  border-radius: 16px;
  box-shadow: 0px 3.19px 27.93px 0px rgba(156, 156, 156, 0.3);
}
.scan >>> .el-image {
  width: 202.65px;
  height: 224px;
}
.tel {
  position: fixed;
  top: 750px;
  right: 80px;
  z-index: 9999;
  width: 194px;
  height: 224px;
  border-radius: 16px;
  box-shadow: 0px 3.19px 27.93px 0px rgba(156, 156, 156, 0.3);
}
.tel >>> .el-image {
  width: 202.65px;
  height: 224px;
}
.consult-item1 {
  width: 40px;
  height: 92px;
  border-radius: 24px;
  margin-bottom: 16px;
  background-image: url("../assets/consult3.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item1-en {
  width: 40px;
  height: 92px;
  border-radius: 24px;
  margin-bottom: 16px;
  background-image: url("../assets/consult3en.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item1-tw {
  width: 40px;
  height: 92px;
  border-radius: 24px;
  margin-bottom: 16px;
  background-image: url("../assets/consult3tw.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item2 {
  width: 40px;
  height: 88px;
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #227110;
  background-image: url("../assets/consult4.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item2-en {
  width: 40px;
  height: 88px;
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #227110;
  background-image: url("../assets/consult4en.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item2-tw {
  width: 40px;
  height: 88px;
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #227110;
  background-image: url("../assets/consult4tw.png");
  background-size: cover;
  cursor: pointer;
}
.white {
  color: #fff;
}
::v-deep .el-input__inner {
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #2e7516;
}
::v-deep .el-input__inner::placeholder {
  color: #9f9f9f;
}
.reservation {
  width: 190px;
  height: 48px;
  line-height: 48px;
  border-radius: 27px;
  background: rgba(46, 117, 22, 0.5);
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* color-white */
  color: #ffffff;
  margin: 40px auto 0px;
  cursor: pointer;
}
.scale {
  transform: scale(1.1); /* 放大10% */
}
.footer_logo_image {
  width: 224px;
  height: 68px;
  margin: 60px 0px 22px;
}
.footer_logo_text {
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: 40px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
}
.beian {
  width: 100%;
  height: 90px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 90px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #787878;
  border-top: 1px solid #2a494f;
}
.text-translation {
  height: 1078px;
  padding-top: 61px;
  box-sizing: border-box;
}
.lang {
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  text-align: center;
  margin: 29px 40px 0px 24px;
  border: 2px solid #172b2f;
  font-size: 16px;
  cursor: pointer;
  box-sizing: border-box;
}
.person_logo_image {
  width: 40px;
  height: 40px;
  margin: 25px 10px 0px 0px;
}
.phone {
  font-size: 14px;
}
.image1 {
  width: 104px;
  height: 38px;
  cursor: pointer;
}
.image2 {
  width: 114px;
  height: 40px;
  cursor: pointer;
}
.image3 {
  width: 124px;
  height: 31px;
  cursor: pointer;
}
.image4 {
  width: 123px;
  height: 43px;
  cursor: pointer;
}
.image5 {
  width: 126px;
  height: 43px;
  cursor: pointer;
}
.engine {
  width: 1200px;
  margin: 61px auto 0px;
}
.engine-img {
  width: 192px;
  height: 68px;
  line-height: 68px;
  margin: 0px 24px 40px 0px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 16px;
  padding-top: 15px;
  border: 1px solid #dfdfdf;
}
.engine-img2 {
  width: 192px;
  height: 68px;
  line-height: 68px;
  margin: 0px 24px 40px 0px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 16px;
  padding-top: 10px;
  border: 1px solid #dfdfdf;
}
.engine-img-active {
  border: 2px solid #2e7516;
}
.engine-translation {
  width: 1200px;
  height: 700px;
  /* border-radius: 24px 24px 0px 0px; */
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  /* border-bottom: none; */
}
.engine-translation-header {
  display: flex;
  width: 1200px;
  height: 68px;
  line-height: 68px;
  border-bottom: 1px solid #dfdfdf;
}
.engine-translation-header-left {
  flex: 1;
  padding-left: 27px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
  cursor: pointer;
}
.engine-translation-header-right {
  height: 632px;
  flex: 1;
  padding-left: 27px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
  cursor: pointer;
}
.input-left {
  position: relative;
  flex: 1;
  height: 632px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
}
.input-right {
  position: relative;
  flex: 1;
  height: 630px;
  background: #fafafa;
  border-radius: 0px 0px 24px 0px;
  padding: 32px 0px 0px 24px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}
.w100 {
  width: 100px;
}
::v-deep .el-textarea__inner {
  border: none;
  font-size: 16px;
  margin-top: 20px;
  resize: none;
}
.clear-btn {
  position: absolute;
  top: 20px;
  right: 10px;
  font-size: 24px;
}
.line2 {
  width: 27px;
  height: 3px;
  background: #227110;
  margin-left: 20px;
}
.line3 {
  width: 27px;
  height: 3px;
  background: #227110;
  margin: 15px 0px 0px 5px;
}
.translatePanel {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 611px;
  height: 572px;
  border-radius: 0px 0px 24px 24px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  background: #ffffff;
  overflow-y: auto;
}
.input-right-bottom {
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 60px;
  line-height: 60px;
  padding: 0px 24px;
  box-sizing: border-box;
}
.waifangImg {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.translatePanelContent {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  margin: 16px 24px;
}
.translatePanelContentItem {
  flex: 0 0 calc((100% - 8px) / 3); /* 计算三等分宽度，含间隙 */
  padding: 8px; /* 项目间距 */
  box-sizing: border-box; /* 确保padding不影响宽度计算 */
  cursor: pointer;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 42px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
}
.green {
  color: #2e7516;
  font-weight: 500;
}
.errorText1 {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 辅色 */
  color: #172b2f;
}
.convertImg {
  width: 28px;
  height: 24px;
  cursor: pointer;
}
.mt6 {
  margin-top: 6px;
}
.console-content {
  position: relative;
  min-height: 1078px;
  padding-top: 61px;
  box-sizing: border-box;
  width: 1200px;
  margin: 61px auto 0px;
}
.console-tabs {
  display: flex;
}
.console-tab-active {
  border: 2px solid #2e7516 !important;
}
.console-tab {
  width: 271px;
  height: 68px;
  border-radius: 16px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  font-family: Source Han Sans;
  font-size: 24px;
  font-weight: normal;
  line-height: 66px;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #2e7516;
  box-sizing: border-box;
  margin-right: 40px;
  cursor: pointer;
}
.console-tab-line {
  width: 1200px;
  height: 0px;
  border-top: 1px solid #dfdfdf;
  margin-top: 24px;
}
.console-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 44px 0px 48px 0px;
}
.console-title-left {
  font-family: Source Han Sans;
  font-size: 36px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
}
.console-title-right {
  display: flex;
  /* font-family: Source Han Sans; */
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" auto; */
  /* font-feature-settings: "kern" on; */
  color: #3d3d3d;
}
.console-title-right-item2 {
  margin-left: 16px;
  /* font-family: Source Han Sans; */
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" auto; */
  /* font-feature-settings: "kern" on; */
  color: #9f9f9f;
}
.console-title-right-item1 {
  padding-top: 8px;
}
.console-table {
  margin-top: 1px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.popover-content {
  width: 100%;
  min-height: 38px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background: #f5f5f5;
  padding: 8px;
  margin-top: 16px;
}
.console-tip {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  text-align: left;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 26px 0px 58px 0px;
}
.console-tip-item2 {
  padding-left: 48px;
}
.echart-title {
  font-family: Source Han Sans;
  font-size: 24px;
  font-weight: bold;
  line-height: normal;
  text-align: left;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
}
.echart-header {
  display: flex;
  justify-content: space-between;
}
.echart-header-right {
  display: flex;
  width: 295px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  background: #f5f5f5;
  text-align: center;
}
.echart-header-right-item {
  flex: 1;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  box-sizing: border-box;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
  cursor: pointer;
}
.echart-header-right-item-active {
  border: 1px solid #2e7516;
  border-radius: 8px;
  color: #2e7516;
}
.langs {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  top: 90px;
  right: 500px;
  width: 152px;
  height: 124px;
  z-index: 9999;
  background: #f5f5f5;
  border-radius: 24px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
  cursor: pointer;
}
.lang-en {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  top: 90px;
  right: 500px;
  min-width: 152px;
  height: 124px;
  z-index: 9999;
  background: #f5f5f5;
  border-radius: 24px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
  cursor: pointer;
}
.lang-active {
  color: #2e7516;
  font-weight: 500;
}
.tabItem1 {
  min-width: 36px;
}
.tabItem2 {
  min-width: 72px;
}
.appDown {
  margin-top: 30px;
  margin-right: 16px;
  cursor: pointer;
  min-width: 36px;
  height: 30px;
  line-height: 30px;
  color: #172b2f;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
}
a {
  text-decoration: none;
}
.m16 {
  margin: 0px 16px;
}
.cur {
  cursor: pointer;
}
.appDownImg {
  width: 112px;
  height: 40px;
  cursor: pointer;
  margin-top: 24px;
  box-sizing: border-box;
}
.appDownImg2 {
  width: 164px;
  height: 40px;
  cursor: pointer;
  margin-top: 24px;
  box-sizing: border-box;
}
.price2 {
  font-family: Source Han Sans;
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
}
/* style-end */
</style>
<template>
  <div id="app">
    <div
      :class="{
        header: $i18n.locale === 'cn' || $i18n.locale === 'tw',
        header2: $i18n.locale === 'en',
      }"
    >
      <div class="logo">
        <el-image class="logo_image" :src="logoImg" fit="fill" />
      </div>
      <div class="tabs">
        <div class="pr50 crp tabItem1" @click="handleTabs(1)">
          <span :class="{ 'tab-active-text': tabIndex === 1 }">{{
            $t("HomePage.headerText1")
          }}</span>
        </div>
        <div class="pr50 crp tabItem2" @click="handleTabs(2)">
          <span :class="{ 'tab-active-text': tabIndex === 2 }">{{
            $t("HomePage.headerText2")
          }}</span>
        </div>

        <div class="pr50 crp" @click="handleTabs(3)">
          <span :class="{ 'tab-active-text': tabIndex === 3 }">{{
            $t("HomePage.headerText3")
          }}</span>
        </div>
        <!-- <div class="pr50 crp" @click="handleTabs(4)">
          <span :class="{ 'tab-active-text': tabIndex === 4 }">{{$t("HomePage.headerText4")}}</span>
        </div> -->
        <div>
          <span
            :class="{
              'el-dropdown-link': true,
              ziyuan: true,
              crp: true,
              'tab-active-text': tabIndex === 5,
            }"
            @click="handleTabs(5)"
          >
            {{ $t("HomePage.headerText5")
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
        </div>
      </div>
      <div class="login" v-if="!isLogin">
        <div class="lang" @click="handleLangs">{{ langName }}</div>
        <el-button class="login-button" @click="toLogin">{{
          $t("HomePage.buttonText1")
        }}</el-button>
      </div>
      <div class="login" v-else>
        <div class="lang" @click="handleLangs">{{ langName }}</div>
        <div @click="handleConsole()">
          <el-image class="person_logo_image" :src="personLogoImg" fit="fill" />
        </div>
        <div class="phone" @click="handleConsole()">
          <span
            :class="{
              'el-dropdown-link': true,
              ziyuan: true,
              crp: true,
            }"
          >
            {{ account
            }}<i class="el-icon-arrow-down el-icon--right" v-if="account"></i>
          </span>
        </div>
      </div>
    </div>
    <div
      :class="{
        langs: $i18n.locale === 'cn' || $i18n.locale === 'tw',
        'lang-en': $i18n.locale === 'en',
      }"
      v-if="showLangs"
    >
      <div
        :class="{ 'lang-active': langIndex === 1 }"
        @click="handleLangItem(1)"
      >
        {{ $t("HomePage.langText1") }}
      </div>
      <div
        :class="{ 'lang-active': langIndex === 2 }"
        @click="handleLangItem(2)"
      >
        {{ $t("HomePage.langText2") }}
      </div>
      <div
        :class="{ 'lang-active': langIndex === 3 }"
        @click="handleLangItem(3)"
      >
        {{ $t("HomePage.langText3") }}
      </div>
    </div>
    <div class="resources" v-if="showResources">
      <div class="resources-content">
        <div
          :class="{
            'resources-content-item': true,
            'resources-content-item-active': tabIndex2 === 1,
          }"
          @click="handleTabs2(1)"
        >
          <div class="resources-content-item-text1">
            {{ $t("HomePage.resources1") }}
          </div>
          <div class="resources-content-item-text2">
            {{ $t("HomePage.resources2") }}
          </div>
        </div>
        <div
          :class="{
            'resources-content-item': true,
            'resources-content-item-active': tabIndex2 === 2,
          }"
          @click="handleTabs2(2)"
        >
          <div class="resources-content-item-text1">
            {{ $t("HomePage.resources3") }}
          </div>
          <div class="resources-content-item-text2">
            {{ $t("HomePage.resources4") }}
          </div>
        </div>
        <!-- <div
          :class="{
            'resources-content-item': true,
            'resources-content-item-active': tabIndex2 === 3,
          }"
          @click="handleTabs2(3)"
        >
          <div class="resources-content-item-text1">
            {{ $t("HomePage.resources5") }}
          </div>
          <div class="resources-content-item-text2">
            {{ $t("HomePage.resources6") }}
          </div>
        </div> -->
      </div>
    </div>
    <div
      :class="{
        'console-panel': true,
        'console-panel-en': $i18n.locale === 'en',
      }"
      v-if="showConsole"
    >
      <div
        :class="{
          'console-panel-text1': true,
          'console-panel-active': consoleIndex === 1,
        }"
        @click="handleConsoleItem(1)"
      >
        {{ $t("TextTranslation.text1") }}
      </div>
      <div
        :class="{
          'console-panel-text2': true,
          'console-panel-active': consoleIndex === 2,
        }"
        @click="handleConsoleItem(2)"
      >
        {{ $t("TextTranslation.text2") }}
      </div>
    </div>
    <!-- 控制面板 -->
    <div class="console-content">
      <div class="console-tabs">
        <div
          :class="{
            'console-tab': true,
            'console-tab-active': typeIndex === 1,
          }"
          @click="handleType(1)"
        >
          {{ $t("HomePage.headerText2") }}
        </div>
        <div
          :class="{
            'console-tab': true,
            'console-tab-active': typeIndex === 2,
          }"
          @click="handleType(2)"
        >
          {{ $t("HomePage.headerText3") }}
        </div>
      </div>
      <div class="console-tab-line"></div>
      <div class="console-title">
        <div class="console-title-left">{{ $t("ConsolePanel.text11") }}</div>
        <div class="console-title-right">
          <div class="console-title-right-item1">ID：{{ userId }}</div>
          <div class="console-title-right-item2">
            {{ $t("ConsolePanel.text20") }}
            <el-select
              v-model="currency"
              placeholder=""
              style="width: 110px"
              @change="selectCurrency"
            >
              <el-option
                v-for="item in currencys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!-- 文本翻译使用详情 -->
      <div class="console-table" v-if="typeIndex === 1">
        <el-table :data="tableData" border style="width: 100%" stripe>
          <el-table-column
            prop="productName"
            :label="$t('ConsolePanel.text13')"
            :key="0"
            align="center"
          >
            <template slot-scope="scope">
              <div slot="reference">
                <span>{{ getProductName(scope.row.productName) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="originalPrice"
            :label="$t('ConsolePanel.text38')"
            :key="1"
            align="center"
          >
            <template slot-scope="scope">
              <div slot="reference">
                <span v-if="!scope.row.isUsd">¥</span>
                <span v-else>$</span>
                {{ scope.row.originalPrice }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="discountPrice"
            :label="$t('ConsolePanel.text39')"
            :key="2"
            align="center"
          >
            <template slot-scope="scope">
              <div slot="reference">
                <span v-if="scope.row.currency === 'CNY'">¥</span>
                <span v-else>$</span>{{ scope.row.discountPrice }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="used"
            :label="$t('ConsolePanel.text15')"
            :key="3"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="left"
            :label="$t('ConsolePanel.text16')"
            :key="4"
            align="center"
          >
          </el-table-column>

          <el-table-column
            :label="$t('ConsolePanel.text12')"
            width="290"
            align="center"
          >
            <template slot-scope="scope">
              <!-- 公钥 -->
              <el-popover
                placement="bottom"
                :title="
                  getProductName(scope.row.productName) +
                  '    ' +
                  $t('ConsolePanel.text1')
                "
                width="100%"
                trigger="click"
              >
                <div class="popover-content">
                  <div>{{ scope.row.appKey }}</div>
                  <div style="width: 80px; text-align: right">
                    <el-link type="success" @click="copy(scope.row, 1)">{{
                      $t("ConsolePanel.text2")
                    }}</el-link>
                  </div>
                </div>
                <el-link
                  type="success"
                  slot="reference"
                  style="margin-right: 32px"
                  >{{ $t("ConsolePanel.text17") }}</el-link
                >
              </el-popover>
              <!-- 私钥 -->
              <el-popover
                placement="bottom"
                :title="
                  getProductName(scope.row.productName) +
                  '    ' +
                  $t('ConsolePanel.text1')
                "
                width="100%"
                trigger="click"
              >
                <div class="popover-content">
                  <div>{{ scope.row.appSecret }}</div>
                  <div style="width: 80px; text-align: right">
                    <el-link type="success" @click="copy(scope.row, 2)">{{
                      $t("ConsolePanel.text2")
                    }}</el-link>
                  </div>
                </div>
                <el-link
                  type="success"
                  slot="reference"
                  style="margin-right: 32px"
                  >{{ $t("ConsolePanel.text3") }}</el-link
                >
              </el-popover>

              <el-button
                @click="handleClick(scope.row)"
                type="success"
                size="small"
                >{{ $t("ConsolePanel.text4") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 语音翻译使用详情 -->
      <div class="console-table" v-if="typeIndex === 2">
        <el-table
          :data="tableData2"
          border
          style="width: 100%"
          stripe
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="productName"
            :label="$t('ConsolePanel.text13')"
            :key="0"
            align="center"
          >
            <template slot-scope="scope">
              <div slot="reference">
                <span>{{ getProductName(scope.row.productType) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="productName"
            :label="$t('ConsolePanel.text29')"
            :key="1"
            align="center"
          >
            <template slot-scope="scope">
              <div slot="productName">
                {{ getType(scope.row.productName) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="originalPrice"
            :label="$t('ConsolePanel.text30')"
            :key="2"
            align="center"
          >
            <template slot-scope="scope">
              <div slot="reference">
                <span v-if="!scope.row.isUsd">¥</span> <span v-else>$</span
                >{{ scope.row.originalPrice }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="discountPrice"
            :label="$t('ConsolePanel.text31')"
            :key="3"
            align="center"
          >
            <template slot-scope="scope">
              <div slot="reference">
                <span v-if="scope.row.currency === 'CNY'">¥</span>
                <span v-else>$</span> {{ scope.row.discountPrice }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="usedTime"
            :label="$t('ConsolePanel.text32')"
            :key="6"
            align="center"
          >
            <template slot-scope="scope">
              <div slot="reference">
                {{ scope.row.usedTime }} {{ $t("OrderPage.Text4") }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="usedAmount"
            :label="$t('ConsolePanel.text33')"
            :key="7"
            align="center"
          >
            <template slot-scope="scope">
              <div slot="reference">
                <span v-if="scope.row.currency === 'CNY'">¥</span>
                <span v-else>$</span> {{ scope.row.usedAmount }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('ConsolePanel.text34')"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <div class="price2" v-if="scope.row.currency === 'CNY'">
                ¥ {{ leftAmount }}
              </div>
              <div class="price2" v-else>$ {{ leftAmount }}</div>
              <div style="margin: 24px 0px">
                <el-button
                  @click="handleClick(scope.row)"
                  type="success"
                  size="small"
                  >{{ $t("ConsolePanel.text4") }}</el-button
                >
              </div>
              <!-- 公钥 -->
              <el-popover
                placement="bottom"
                :title="
                  getProductName(scope.row.productType) +
                  '    ' +
                  $t('ConsolePanel.text1')
                "
                width="100%"
                trigger="click"
              >
                <div class="popover-content">
                  <div>{{ appKey }}</div>
                  <div style="width: 80px; text-align: right">
                    <el-link type="success" @click="copy(scope.row, 1)">{{
                      $t("ConsolePanel.text2")
                    }}</el-link>
                  </div>
                </div>
                <el-link
                  type="success"
                  slot="reference"
                  style="margin-right: 16px"
                  >{{ $t("ConsolePanel.text17") }}</el-link
                >
              </el-popover>
              <!-- 私钥 -->
              <el-popover
                placement="bottom"
                :title="
                  getProductName(scope.row.productType) +
                  '    ' +
                  $t('ConsolePanel.text1')
                "
                width="100%"
                trigger="click"
              >
                <div class="popover-content">
                  <div>{{ appSecret }}</div>
                  <div style="width: 80px; text-align: right">
                    <el-link type="success" @click="copy(scope.row, 2)">{{
                      $t("ConsolePanel.text2")
                    }}</el-link>
                  </div>
                </div>
                <el-link type="success" slot="reference">{{
                  $t("ConsolePanel.text3")
                }}</el-link>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="console-tip">
        <div>{{ $t("ConsolePanel.text5") }}</div>
        <div class="console-tip-item2">{{ $t("ConsolePanel.text19") }}</div>
      </div>

      <div class="echart-header">
        <div class="echart-title">{{ $t("ConsolePanel.text6") }}</div>
        <div class="echart-header-right">
          <div
            :class="{
              'echart-header-right-item': true,
              'echart-header-right-item-active': index2 === 1,
            }"
            @click="handleTabs3(1)"
          >
            {{ $t("ConsolePanel.text7") }}
          </div>
          <div
            :class="{
              'echart-header-right-item': true,
              'echart-header-right-item-active': index2 === 2,
            }"
            @click="handleTabs3(2)"
          >
            {{ $t("ConsolePanel.text8") }}
          </div>
          <div
            :class="{
              'echart-header-right-item': true,
              'echart-header-right-item-active': index2 === 3,
            }"
            @click="handleTabs3(3)"
          >
            {{ $t("ConsolePanel.text9") }}
          </div>
        </div>
      </div>
      <!-- 文本翻译使用统计图 -->
      <div v-if="typeIndex === 1">
        <LineChart
          ref="LineChart"
          :chartSeries="salesSeries"
          :xAxisLabels="quarters"
          titleText=""
        />
      </div>
      <!-- 语音翻译使用统计图 -->
      <div v-if="typeIndex === 2">
        <LineChart2
          ref="LineChart2"
          :chartSeries="salesSeriesSpeech"
          :xAxisLabels="quarters2"
          titleText=""
        />
      </div>
      <!-- 客服 -->
      <div class="consult">
        <div
          :class="{
            'consult-item1': langName === 'ZH',
            'consult-item1-en': langName === 'EN',
            'consult-item1-tw': langName === 'TW',
          }"
          @click="handleConsult(1)"
          @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave"
        ></div>
        <div
          :class="{
            'consult-item2': langName === 'ZH',
            'consult-item2-en': langName === 'EN',
            'consult-item2-tw': langName === 'TW',
          }"
          @click="handleConsult(2)"
          @mouseenter="handleMouseEnter2"
          @mouseleave="handleMouseLeave2"
        ></div>
      </div>
      <div v-if="isScan" class="scan">
        <el-image :src="scanImgZh" fit="fill" v-if="langName === 'ZH'" />
        <el-image :src="scanWxChat" fit="fill" v-if="langName === 'EN'" />
        <el-image :src="scanWxChatTw" fit="fill" v-if="langName === 'TW'" />
      </div>
      <div v-if="isTel" class="tel">
        <el-image :src="telImgZh" fit="fill" v-if="langName === 'ZH'" />
        <el-image :src="scanWhatApp" fit="fill" v-if="langName === 'EN'" />
        <el-image :src="scanWhatAppTw" fit="fill" v-if="langName === 'TW'" />
      </div>
    </div>
    <div class="footer">
      <div class="footer-bottom">
        <div class="footer-bottom-left">
          <div>
            <el-image
              class="footer_logo_image"
              :src="footerLogoImg"
              fit="fill"
            />
          </div>
          <div class="footer_logo_text">
            <div>{{ $t("HomePage.footer6") }}</div>
            <div>{{ $t("HomePage.footer7") }}</div>
            <div>{{ $t("HomePage.footer8") }}</div>
            <div>{{ $t("HomePage.footer9") }}</div>
          </div>
        </div>
        <!-- <div class="footer-bottom-right">
          <div style="flex: 1; color: #fff">
            <div>翻译</div>
            <div style="margin: 40px 0px">AI大模型</div>
            <div>资源</div>
          </div>
          <div style="flex: 1">
            <div>文本翻译</div>
            <div style="margin: 40px 0px">AI智能体</div>
            <div>API文档</div>
          </div>
          <div style="flex: 1">
            <div>语音翻译</div>
            <div style="margin-top: 105px"></div>
            <div>常见问题</div>
          </div>
        </div> -->
      </div>
      <!-- <div class="beian">港ICP备8384773838282号-1</div> -->
      <div class="beian">
        <span class="cur" @click="handleUserAgreement">{{
          $t("HomePage.text3")
        }}</span>
        <span class="cur m16" @click="handlePrivacyPolicy">{{
          $t("HomePage.text4")
        }}</span>
        <span class="cur" @click="handlePaymentAgreement">{{
          $t("HomePage.text5")
        }}</span>
      </div>
    </div>

    <el-dialog
      :title="$t('LoginPage.text13')"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span class="errorText1">{{ $t("PayPage.text15") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("LoginPage.text15")
        }}</el-button>
        <el-button
          style="background: #2e7516"
          type="success"
          @click="dialogVisible = false"
          >{{ $t("VoicePage.text11") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 用户协议 -->
    <el-dialog
      top="0px"
      title=""
      :visible.sync="dialogVisible2"
      width="100%"
      :before-close="handleClose2"
      :close-on-click-modal="false"
    >
      <UserAgreement v-if="$i18n.locale === 'cn'"></UserAgreement>
      <UserAgreementEn v-else></UserAgreementEn>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button"
          @click="dialogVisible2 = false"
          >{{ $t("HomePage.text6") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 隐私政策 -->
    <el-dialog
      top="0px"
      title=""
      :visible.sync="dialogVisible3"
      width="100%"
      :before-close="handleClose3"
      :close-on-click-modal="false"
    >
      <PrivacyPage v-if="$i18n.locale === 'cn'"></PrivacyPage>
      <PrivacyPageEn v-else></PrivacyPageEn>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button"
          @click="dialogVisible3 = false"
          >{{ $t("HomePage.text6") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 付费协议 -->
    <el-dialog
      top="0px"
      title=""
      :visible.sync="dialogVisible4"
      width="100%"
      :before-close="handleClose4"
      :close-on-click-modal="false"
    >
      <PaidServiceAgreement v-if="$i18n.locale === 'cn'"></PaidServiceAgreement>
      <PaidServiceAgreementEn v-else></PaidServiceAgreementEn>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">{{
          $t("HomePage.text6")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UserAgreement from "@/components/UserAgreement.vue";
import UserAgreementEn from "@/components/UserAgreementEn.vue";
import PrivacyPage from "@/components/PrivacyPage.vue";
import PrivacyPageEn from "@/components/PrivacyPageEn.vue";
import PaidServiceAgreement from "@/components/PaidServiceAgreement.vue";
import PaidServiceAgreementEn from "@/components/PaidServiceAgreementEn.vue";
import { getToken } from "@/utils/auth";
import LineChart from "@/components/LineChart.vue";
import LineChart2 from "@/components/LineChart2.vue";
import { usageDetail, dailyDetail } from "@/api/login/user";
export default {
  name: "ConsolePanel",
  data () {
    return {
      appKey: "",
      appSecret: "",
      leftAmount: "", // 剩余额度
      typeIndex: 1, // 1文本翻译,2语音翻译
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      currencys: [
        {
          value: 'CNY',
          label: 'CNY（¥）'
        },
        {
          value: 'USD',
          label: 'USD（$）'
        }
      ],
      currency: '',
      bizType: "text",
      copyText: "",
      usageType: 1,
      userId: "",
      isLogin: false,
      account: "",
      langName: "ZH",
      langIndex: 2,
      showLangs: false,
      stripe: "",
      publishableKey: "",
      clientSecret: "",
      index2: 2,
      windowWidth: "",
      salesSeriesSpeech: [
        {
          name: "语音转文字识别",
          data: [],
        },
        {
          name: "指定语言语音翻译",
          data: [],
        },
        {
          name: "自动识别语言语音翻译",
          data: [],
        }
      ],
      salesSeriesSpeech1: [
        {
          name: "语音转文字识别",
          data: [],
        },
        {
          name: "指定语言语音翻译",
          data: [],
        },
        {
          name: "自动识别语言语音翻译",
          data: [],
        }
      ],
      salesSeriesSpeech2: [
        {
          name: "Speech-to-text recognition",
          data: [],
        },
        {
          name: "Specify language voice translation",
          data: [],
        },
        {
          name: "Automatic language recognition and voice translation",
          data: [],
        }
      ],
      salesSeriesSpeech3: [
        {
          name: "語音轉文字識別",
          data: [],
        },
        {
          name: "指定語言語音翻譯",
          data: [],
        },
        {
          name: "自動識別語言語音翻譯",
          data: [],
        }
      ],
      salesSeries: [
        {
          name: "Deepl",
          data: [], // Q1-Q4 销售额
        },
        {
          name: "谷歌",
          data: [],
        },
        {
          name: "百度",
          data: [],
        },
        {
          name: "有道",
          data: [],
        },
        {
          name: "火山",
          data: [],
        },
        {
          name: "ChaGPT",
          data: [],
        },
        {
          name: "yandex",
          data: [],
        },
        {
          name: "Microsoft",
          data: [],
        },
      ],
      salesSeries1: [
        {
          name: "Deepl",
          data: [], // Q1-Q4 销售额
        },
        {
          name: "谷歌",
          data: [],
        },
        {
          name: "百度",
          data: [],
        },
        {
          name: "有道",
          data: [],
        },
        {
          name: "火山",
          data: [],
        },
        {
          name: "ChaGPT",
          data: [],
        },
        {
          name: "yandex",
          data: [],
        },
        {
          name: "Microsoft",
          data: [],
        },
      ],
      salesSeries2: [
        {
          name: "Deepl",
          data: [], // Q1-Q4 销售额
        },
        {
          name: "Google",
          data: [],
        },
        {
          name: "Baidu",
          data: [],
        },
        {
          name: "Youdao",
          data: [],
        },
        {
          name: "volcano",
          data: [],
        },
        {
          name: "ChaGPT",
          data: [],
        },
        {
          name: "yandex",
          data: [],
        },
        {
          name: "Microsoft",
          data: [],
        },
      ],
      salesSeries3: [
        {
          name: "Deepl",
          data: [], // Q1-Q4 销售额
        },
        {
          name: "穀歌",
          data: [],
        },
        {
          name: "百度",
          data: [],
        },
        {
          name: "有道",
          data: [],
        },
        {
          name: "火山",
          data: [],
        },
        {
          name: "ChaGPT",
          data: [],
        },
        {
          name: "yandex",
          data: [],
        },
        {
          name: "Microsoft",
          data: [],
        },
      ],
      quarters: [],
      quarters2: [],
      quarters1: [
        "05-29",
        "05-31",
        "06-02",
        "06-03",
        "06-04",
        "06-05",
        "06-06",
      ], // 自定义 X 轴标签
      salesData: [
        { name: "一月", value: 120 },
        { name: "二月", value: 200 },
        { name: "三月", value: 150 },
        { name: "四月", value: 80 },
        { name: "五月", value: 70 },
        { name: "六月", value: 110 },
        { name: "七月", value: 250 },
        { name: "八月", value: 130 },
        { name: "九月", value: 190 },
        { name: "十月", value: 220 },
        { name: "十一月", value: 300 },
        { name: "十二月", value: 280 },
      ],
      tableData: [],
      tableData1: [
        {
          id: 0,
          engine: "DeepL",
          price: 60,
          used: 0,
          remainder: 10000,
          secretKey: "bhMEx6a4CkYsyHXk9Quw1",
        },
        {
          id: 1,
          engine: "谷歌翻译",
          price: 60,
          used: 0,
          remainder: 10000,
          secretKey: "bhMEx6a4CkYsyHXk9Quw2",
        },
        {
          id: 3,
          engine: "微软翻译",
          price: 60,
          used: 0,
          remainder: 10000,
          secretKey: "bhMEx6a4CkYsyHXk9Quw3",
        },
      ],
      tableData2: [],
      columns: [
        {
          id: 0,
          value: "engine",
          name: "翻译引擎",
        },
        {
          id: 1,
          value: "price",
          name: "价格（元/百万字符）",
        },
        {
          id: 2,
          value: "used",
          name: "已使用字符数",
        },
        {
          id: 3,
          value: "remainder",
          name: "剩余字符数",
        },
      ],
      consoleIndex: 1,
      showResources: false,
      dialogVisible: false,
      showTranslatePanel: false,
      lang1: "自动检测",
      lang2: "英文",
      lang3: "中文（简体）",
      translateList: [
        {
          name: "中文(简体)",
          value: "cn",
          isChecked: false,
        },
        {
          name: "中文(繁体)",
          value: "tw",
          isChecked: false,
        },
        {
          name: "英文",
          value: "en",
          isChecked: false,
        },
        {
          name: "法语",
          value: "fr",
          isChecked: false,
        },
        {
          name: "德语",
          value: "de",
          isChecked: false,
        },
        {
          name: "意大利",
          value: "it",
          isChecked: false,
        },
        {
          name: "日语",
          value: "ja",
          isChecked: false,
        },
        {
          name: "韩语",
          value: "ko",
          isChecked: false,
        },
      ],
      translateText: "翻译展示",
      hasContent: false,
      isFocused: false,
      isHovered: true,
      isHovered2: true,
      textarea1: "",
      engineTabIndex: 1,
      showConsole: false,
      isReservation: false,
      input1: "",
      input2: "",
      tabIndex: '',
      tabIndex2: 1,
      logoImg: require("@/assets/login-logo.png"),
      personLogoImg: require("@/assets/person-logo.png"),
      logo: require("@/assets/logo.png"),
      footerLogoImg: require("@/assets/footer-logo.png"),
      img1: require("@/assets/img1.png"),
      img2: require("@/assets/img2.png"),
      img3: require("@/assets/img3.png"),
      img4: require("@/assets/img4.png"),
      img5: require("@/assets/img5.png"),
      gouImg: require("@/assets/gou2.png"),
      img6: require("@/assets/convert.png"),
      img7: require("@/assets/waifang.png"),
      img8: require("@/assets/fuzhi.png"),
      appDown1Img: require("@/assets/appDown1.png"),
      appDown2Img: require("@/assets/appDown2.png"),
      appDown3Img: require("@/assets/appDown3.png"),
      isTel: false,
      isScan: false,
      scanImgZh: require("@/assets/scan1.png"),
      scanImgEn: require("@/assets/scan-en.png"),
      telImgZh: require("@/assets/scan2.png"),
      telImgEn: require("@/assets/tel-en.png"),
      scanWxChat: require("@/assets/scan-wxchat.png"),
      scanWhatApp: require("@/assets/scan-whatapp.png"),
      scanWxChatTw: require("@/assets/scan-wxchat-tw.png"),
      scanWhatAppTw: require("@/assets/scan-whatapp-tw.png"),
    };
  },
  components: { LineChart, LineChart2, UserAgreement, UserAgreementEn, PrivacyPage, PrivacyPageEn, PaidServiceAgreement, PaidServiceAgreementEn },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query?.typeIndex) {
          console.log("query---123", query);
          this.typeIndex = Number(query?.typeIndex)
          if (this.typeIndex === 1) {
            this.bizType = 'text'
          } else {
            this.bizType = 'voice'
          }
        }
      },
      immediate: true
    }
  },
  async mounted () {
    this.currency = this.$i18n.locale === 'cn' ? 'CNY' : 'USD'
    if (localStorage.getItem("userId")) {
      this.userId = localStorage.getItem("userId");
      console.log("this.userId", this.userId);
    }
    this.usageDetailNet();
    if (localStorage.getItem("acount")) {
      this.account = localStorage.getItem("acount");
      console.log("this.account", this.account);
      const value = getToken();
      if (value) {
        this.isLogin = true;
      }
    }

    this.setImgs();
    this.dailyDetailNet();
  },
  methods: {
    getType (val) {
      // asr：微软语音识别       sl_asr:微软指定语言语言识别   al_asr:微软自动识别语言语言翻译 
      const list = {
        'asr': this.$t("ConsolePanel.text35"),
        'sl_asr': this.$t("ConsolePanel.text36"),
        'al_asr': this.$t("ConsolePanel.text37")
      }
      return list[val]
    },
    handleMouseEnter () {
      this.isScan = true;
    },
    handleMouseLeave () {
      this.isScan = false;
    },
    handleMouseEnter2 () {
      this.isTel = true;
    },
    handleMouseLeave2 () {
      this.isTel = false;
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      console.log('objectSpanMethod', row, column, rowIndex);

      if (columnIndex === 6) {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    handleType (val) {
      this.typeIndex = val
      if (this.typeIndex === 1) {
        this.bizType = 'text'
      } else {
        this.bizType = 'voice'
      }
      console.log('this.typeIndex', this.typeIndex);
      this.dailyDetailNet()

    },
    handleDown (val) {
      if (val === 1) {
        window.open('https://www.xuanjiai.cn/app/download/index.html')
      }
      if (val === 2 || val === 3) {
        window.open('https://www.xuanjiai.cn/app/download/abroad.html')
      }
    },
    handleUserAgreement () {
      this.dialogVisible2 = true;
      this.showLangs = false;
    },
    handlePrivacyPolicy () {
      this.dialogVisible3 = true;
      this.showLangs = false;
    },
    handlePaymentAgreement () {
      this.dialogVisible4 = true;
      this.showLangs = false;
    },
    agree2 () {
      this.dialogVisible4 = false;
    },
    handleOk () {
      this.dialogVisible2 = false;
    },
    handleOk3 () {
      this.dialogVisible3 = false;
    },
    handleClose2 () {
      this.dialogVisible2 = false;
    },
    handleClose3 () {
      this.dialogVisible3 = false;
    },
    handleClose4 () {
      this.dialogVisible4 = false;
    },
    getProductName (val) {
      const list = {
        'baidu_trans': this.$t("ConsolePanel.text24"),
        'youdao_trans': this.$t("ConsolePanel.text25"),
        'deepl_trans': this.$t("ConsolePanel.text21"),
        'google_trans': this.$t("ConsolePanel.text22"),
        'huoshan_trans': this.$t("ConsolePanel.text26"),
        'microsoft_trans': this.$t("ConsolePanel.text23"),
        'chatgpt_trans': this.$t("ConsolePanel.text27"),
        'yandex_trans': this.$t("ConsolePanel.text28"),
        'microsoft': this.$t("ConsolePanel.text23")
      }
      return list[val]
    },
    selectCurrency () {
      console.log('this.currency123', this.currency);
      this.usageDetailNet()
    },
    // 每日使用量
    dailyDetailNet () {
      const params = {
        bizType: this.bizType, // 文本:text 语音:voice
        usageType: this.usageType, // 0:近7天 1: 15天 2: 30天
      };
      dailyDetail(params).then((res) => {
        console.log("每日使用量", res);
        if (res?.data?.list) {
          const data = res.data.list;
          console.log("data-----每日使用量---文本翻译", data);

          if (this.$refs.LineChart) {
            this.quarters = data.map((item) => item.date);
            this.$refs.LineChart.initChart();
            this.salesSeries[0].data = data.map((item) => item.deepl); // Deelp
            this.salesSeries[1].data = data.map((item) => item.google); // 谷歌
            this.salesSeries[2].data = data.map((item) => item.baidu); // 百度
            this.salesSeries[3].data = data.map((item) => item.youdao); // 有道
            this.salesSeries[4].data = data.map((item) => item.huoshan); // 火山
            this.salesSeries[5].data = data.map((item) => item.chatgpt); // ChaGPT
            this.salesSeries[6].data = data.map((item) => item.yandex); // yandex
            this.salesSeries[7].data = data.map((item) => item.microsoft); // microsoft
          }




        }
        if (res?.data?.voiceList) {
          const data2 = res.data.voiceList;
          console.log("data2-----每日使用量---语音翻译", data2);
          if (this.$refs.LineChart2) {
            this.quarters2 = data2.map((item) => item.date);
            this.salesSeriesSpeech[0].data = data2.map((item) => item.asr)
            this.salesSeriesSpeech[1].data = data2.map((item) => item.slAsr)
            this.salesSeriesSpeech[2].data = data2.map((item) => item.alAsr)
            this.$refs.LineChart2.initChart();
          }
        }
      });
    },
    // 使用详情
    usageDetailNet () {

      const params = {
        currency: this.currency
      }

      console.log('使用详情---params', params);

      usageDetail(params).then((res) => {
        console.log("使用详情", res);
        if (res?.text?.textTrans) {
          const data = res?.text?.textTrans;
          console.log("data---文本翻译", data);
          this.tableData = res?.text?.textTrans;
        }
        if (res?.voice?.voiceTrans) {
          const data = res?.voice?.voiceTrans;
          console.log("data----语音翻译", data);
          this.tableData2 = res?.voice?.voiceTrans
          this.appKey = res?.voice?.appKey
          this.appSecret = res?.voice?.appSecret
          this.leftAmount = res?.voice?.leftAmount
        }
      });
    },
    toLogin () {
      this.$router.push({
        path: "/LoginPage",
      });
    },
    handleLangItem (val) {
      this.langIndex = val;
      if (val === 1) {
        this.langName = "TW";
        this.$i18n.locale = "tw";
        localStorage.setItem("lang", "tw");
        localStorage.setItem("acceptLanguage", "zh-TW");
        this.salesSeries = this.salesSeries3;
        this.salesSeriesSpeech = this.salesSeriesSpeech3
      }
      if (val === 2) {
        this.langName = "ZH";
        this.$i18n.locale = "cn";
        localStorage.setItem("lang", "cn");
        localStorage.setItem("acceptLanguage", "zh-CN");
        this.salesSeries = this.salesSeries1;
        this.salesSeriesSpeech = this.salesSeriesSpeech1
      }
      if (val === 3) {
        this.langName = "EN";
        this.$i18n.locale = "en";
        localStorage.setItem("lang", "en");
        localStorage.setItem("acceptLanguage", "en");
        this.salesSeries = this.salesSeries2;
        this.salesSeriesSpeech = this.salesSeriesSpeech2
      }
      this.showLangs = false;
      this.currency = this.$i18n.locale === 'cn' ? 'CNY' : 'USD'
      this.dailyDetailNet();
      this.usageDetailNet()
      console.log("this.salesSeries", this.salesSeries);
    },
    handleLangs () {
      this.showLangs = !this.showLangs;
      this.showConsole = false;
      this.showResources = false
    },
    setImgs () {
      console.log(
        'setImgs,localStorage.getItem("lang")',
        localStorage.getItem("lang")
      );

      if (localStorage.getItem("lang") === "cn") {
        this.langName = "ZH";
        this.salesSeries = this.salesSeries1;
        this.salesSeriesSpeech = this.salesSeriesSpeech1
        this.langIndex = 2
      }
      if (localStorage.getItem("lang") === "tw") {
        this.langName = "TW";
        this.salesSeries = this.salesSeries3;
        this.salesSeriesSpeech = this.salesSeriesSpeech3
        this.langIndex = 1
      }
      if (localStorage.getItem("lang") === "en") {
        this.langName = "EN";
        this.salesSeries = this.salesSeries2;
        this.salesSeriesSpeech = this.salesSeriesSpeech2
        this.langIndex = 3
      }
    },
    handleTabs3 (val) {
      this.index2 = val;
      if (val === 1) {
        this.usageType = 0;
      }
      if (val === 2) {
        this.usageType = 1;
      }
      if (val === 3) {
        this.usageType = 2;
      }
      this.dailyDetailNet();
    },
    copy (val, type) {
      console.log("val", val);
      console.log("type", type);
      if (this.typeIndex === 1) {
        if (type === 1) {
          this.copyText = val.appKey;
        }
        if (type === 2) {
          this.copyText = val.appSecret;
        }
      } else {
        if (type === 1) {
          this.copyText = this.appKey;
        }
        if (type === 2) {
          this.copyText = this.appSecret;
        }
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(this.copyText)
          .then(() => {
            // this.message = this.$t("OffLineResult.copySuccess");
            this.$message.success(this.$t("ConsolePanel.text10"));
          })
          .catch((err) => {
            console.error("Failed to copy text: ", err);
          });
        return;
      }
    },
    handleClick (val) {
      console.log("val-----订单信息", val);
      val.leftAmount = this.leftAmount
      localStorage.setItem("orderDetail", JSON.stringify(val));
      this.$router.push({
        path: "/PayPage",
        query: {
          bizType: val.bizType,
        },
      });
    },
    handleConsoleItem (val) {
      this.consoleIndex = val;
      if (val === 1) {
        console.log("控制台");
        this.showConsole = false;
      }
      if (val === 2) {
        console.log("退出");
        this.$store.dispatch("user/resetToken").then((res) => {
          console.log("res----user/resetToken", res);
        });
        localStorage.removeItem("acount");
        localStorage.removeItem("refreshToken");
        this.$router.push({
          path: "/LoginPage",
        });
      }
    },
    handlePlay () {
      console.log("播放");
    },
    handleCopy () {
      console.log("复制");
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(this.translateText)
          .then(() => {
            // this.message = this.$t("OffLineResult.copySuccess");
            this.$message.success(this.$t("ConsolePanel.text10"));
          })
          .catch((err) => {
            console.error("Failed to copy text: ", err);
          });
        return;
      }
    },
    handleConver () {
      if (this.lang1 === "自动检测") {
        this.lang1 = this.lang2;
      } else {
        this.lang1 = "自动检测";
      }
    },
    handleClose () {
      this.dialogVisible = false;
    },
    onSelect () {
      this.showTranslatePanel = !this.showTranslatePanel;
    },
    handleItem (val) {
      console.log(val);
      this.translateList.forEach((item) => {
        if (item.value === val.value) {
          item.isChecked = true;
          this.lang2 = item.name;
          this.showTranslatePanel = false;
        } else {
          item.isChecked = false;
        }
      });
    },
    onFocus () {
      console.log("onFocus");
      this.isFocused = true;
    },
    onInput () {
      this.hasContent = !!this.textarea1.trim();
      console.log("this.hasContent", this.hasContent);
      //   this.translateText = 'Hello AI'
    },
    clearContent () {
      this.textarea1 = "";
      this.$refs.textarea.focus(); // 保持焦点在输入框
      this.hasContent = false;
    },
    handleEngine (val) {
      this.engineTabIndex = val;
    },
    handleConsole () {
      this.showConsole = !this.showConsole;
      this.showLangs = false;
    },
    handleReservation () {
      this.isReservation = true;
      setTimeout(() => {
        this.isReservation = false;
      });
    },
    handleTabs2 (val) {
      if (val === 1) {
        this.tabIndex2 = 1;
        this.$router.push({
          path: "/APIPage2",
        });
      }
      if (val === 2) {
        this.tabIndex2 = 2;
        this.$router.push({
          path: "/FAQPage",
        });
      }
      if (val === 3) {
        this.tabIndex2 = 3;
      }
    },
    handleTabs (val) {
      this.showLangs = false
      if (val === 1) {
        console.log("首页");
        this.tabIndex = 1;
        this.$router.push({
          path: "/HomePage",
        });
      }
      if (val === 2) {
        console.log("文本翻译");
        this.tabIndex = 2;
        this.$router.push({
          path: "/TextTranslation",
        });
      }
      if (val === 3) {
        console.log("语音翻译");
        this.tabIndex = 3;
        this.$router.push({
          path: "/VoicePage",
        });
      }
      if (val === 4) {
        console.log("AI智能体");
        this.tabIndex = 4;
        this.$message.success(this.$t("HomePage.expect"));
      }
      if (val === 5) {
        console.log("资源");
        this.tabIndex = 5;
        this.showResources = !this.showResources;
      }
    },
  },
};
</script>
